import React from 'react';
import PropTypes from 'prop-types';
import {
    TableRow,
    TableRowColumn
} from 'material-ui/Table';

const styles = {
    row: {height: '38px'},
    rowWithTerm: {backgroundColor: '#e0e2e6', height: '38px'},
    column: {height: '38px', paddingLeft: '20px', paddingRight: '20px'},
    columnFirst: {paddingLeft: '36px'},
    columnRight: {height: '38px', textAlign: 'right', paddingLeft: '20px', paddingRight: '20px'},
};

/**
 * Determine if row is a result containing the search term
 *
 * @param data
 * @param searchTerm
 * @param type
 * @returns {boolean}
 */
const isSearchResult = (data, searchTerm, type) => {
    let product = (data.product_name) ? data.product_name.toLowerCase() : '';
    let search = (searchTerm) ? searchTerm.toLowerCase() : '';
    return type !== 'any' && product !== '' && search !== '' && product.indexOf(search) !== -1;
};

/**
 * Component to display a Transferred Product in a table row
 *
 * @param data
 * @param searchTerm
 * @param type
 * @returns {JSX.Element}
 * @constructor
 */
const TransferListProductTableRow = ({data, searchTerm, type}) => (
    <TableRow style={(isSearchResult(data, searchTerm, type) === true) ? styles.rowWithTerm : styles.row}>
        <TableRowColumn style={{...styles.column, ...styles.columnFirst}}>
            {data.barcode}
        </TableRowColumn>
        <TableRowColumn style={styles.column}>
            {data.product_name} ({data.unit_type})
        </TableRowColumn>
        <TableRowColumn style={styles.columnRight}>
            {data.qty}
        </TableRowColumn>
        <TableRowColumn style={styles.columnRight}>
            {data.unit_qty}
        </TableRowColumn>
    </TableRow>
);

TransferListProductTableRow.propTypes = {
    data: PropTypes.object.isRequired,
    searchTerm: PropTypes.string,
    type: PropTypes.string
};

TransferListProductTableRow.defaultProps = {
    searchTerm: '',
    type: 'any'
};

export default TransferListProductTableRow;


// WEBPACK FOOTER //
// ./src/Fuse/components/TransferListProductTableRow.js